
// src/web/components/unavailable-page.jsx

import React from 'react'
import { translate } from 'react-i18next'
import { pushRoute } from '../../actions/route'
import {
  Button
} from 'react-toolbox/lib/button'

class UnavailablePage extends React.Component {
  setDocumentTitle = ()=> document.title = this.props.t('label:サービスは現在ご利用いただけません') + ' - gamba!'

  componentDidMount() {
    this.setDocumentTitle()
    this.timer = setInterval(this.checkService, 30 * 1000)
  }

  componentWillUnmount() {
    this.timer && clearInterval(this.timer)
  }

  checkService = ()=> pushRoute('main')

  render() {
    const {
      t
    } = this.props

    return (
      <div style={{ padding: 30 }}>
        <h1 style={{ fontFamily: '"Century Gothic", Questrial, sans-serif', fontWeight: 'bold', color: 'red' }}>
          gamba!
        </h1>

        <div style={{ width: '100%' }}>
          <h3>{t('label:サービスは現在ご利用いただけません')}</h3>
          <div>{t('message:メンテナンス中')}</div>
          <img src={"https://gamba-v2-assets.s3-ap-northeast-1.amazonaws.com/assets/maintenance-gambakun.png"}
          style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
        </div>

        <Button raised 
            label={t('label:お知らせページを開く')}
            href={'https://www.getgamba.com/info/'}
            target='_blank' rel="noopener noreferrer" />
      </div>
    )
  }
}

export default translate()(UnavailablePage)



// WEBPACK FOOTER //
// ./src/web/components/unavailable-page.jsx